import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { FareRulesInfo } from "../../../components/elements/FlightDetailsInner/components/FlightDetailsInfo/Items/FareRulesInfo/useFareRulesInfo.controller";

const expConfig = {
  stages: {
    default: 1,
    main: 2,
    direct: 3,
    oneWayCombination: 4,
    change_paid: 5,
    cancel_paid: 6,
    change_free: 7,
    cancel_free: 8,
    change_paid_and_cancel_paid: 9
  },
  goals: {
    change_free: 1,
    change_paid: 2,
    cancel_free: 3,
    cancel_paid: 4,
    check_and_pay_fare_rules_link_click: 5
  }
};

const desktop = createTrackingUtils({
  ...expConfig,
  name: "flights_web_fd_rename_fare_rules_desktop",
  defaultStage: 1
});

const mDot = createTrackingUtils({
  ...expConfig,
  name: "flights_web_fd_rename_fare_rules_mdot",
  defaultStage: 1
});

const getExp = (isMobile: boolean) => {
  return isMobile ? mDot : desktop;
};

const trackStages = (
  profiler: ReturnType<typeof useProfiler>,
  fareRules: FareRulesInfo,
  isOneWayCombination: boolean
) => {
  const { isMobile, isDirect } = profiler;
  const { stages, goals } = getExp(isMobile());

  stages.main();
  isDirect() && stages.direct();
  isOneWayCombination && stages.oneWayCombination();

  if (fareRules.changeable?.free === false) {
    stages.change_paid();
    goals.change_paid();
  }
  if (fareRules.cancellable?.free === false) {
    stages.cancel_paid();
    goals.cancel_paid();
  }
  if (fareRules.changeable?.free === true) {
    stages.change_free();
    goals.change_free();
  }
  if (fareRules.cancellable?.free === true) {
    stages.cancel_free();
    goals.cancel_free();
  }
  if (fareRules.changeable?.free === false && fareRules.cancellable?.free === false) {
    stages.change_paid_and_cancel_paid();
  }
};

export default { getExp, trackStages };
